import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Location} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ConsentsFormService} from '../../../services/consents-form.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {AddOptionsDialogComponent} from './add-options-dialog/add-options-dialog.component';

@Component({
    selector: 'app-custom-form-creator',
    templateUrl: './custom-form-creator.component.html',
    styleUrls: ['./custom-form-creator.component.scss']
})
export class CustomFormCreatorComponent implements OnInit {
    directionTypes = [{id: 1, type: 'start start center', label: 'Αρχή'}, {id: 2, type: 'center start center', label: 'Κέντρο'}, { id: 3, type: 'end start center', label: 'Τέλος' }];
    formDescription: string;
    formTitle: string;
    form: any;
    mode: boolean;
    numberOfSections: number;
    uniqueId: string;
    isLoading: boolean;
    sectionTypes = [{id: 1, type: 'text', label: 'Κείμενο'}, {id: 2, type: 'checkbox', label: 'Πολλαπλής επιλογής'}, {id: 3, type: 'radio', label: 'Απλής επιλογής'}, {id: 4, type: 'toggle', label: 'ΝΑΙ/ΟΧΙ'}, { id: 5, type: 'select', label: 'Dropdown'},
        {id: 6, type: 'textarea', label: 'Περιοχή κειμένου'}, { id: 7, type: 'label', label: 'Ετικέτα'}];
    sections = [];
    constructor(public dialog: MatDialog,
                public location: Location,
                public route: ActivatedRoute,
                private consentFormService: ConsentsFormService,
                public toastMessagesService: ToastMessagesService,
                private commonService: CommonService) {
        this.numberOfSections = 1;
        this.formDescription = '';
        this.formTitle = '';
        this.isLoading = true;
        const defaultSection = {
            id: 1,
            expanded: true,
            label: 'Τίτλος',
            value: `Tίτλος τμήμα ${this.sections.length + 1}`,
            subLabel: 'Yπότιτλος',
            subLabelValue: '',
            direction: this.directionTypes[0],
            members: []
        };
        this.sections.push(defaultSection);

        // const storedFormJson = localStorage.getItem('storedForm');
        // if (storedFormJson) {
        //     const storedForm = JSON.parse(storedFormJson);
        //     this.formTitle = storedForm.formTitle;
        //     this.formDescription = storedForm.formDescription;
        //     this.sections = JSON.parse(storedForm.sections);
        //
        //     for (const section of this.sections) {
        //         for (const member of section.members) {
        //             const type = this.sectionTypes.find(t => t.id === member.type.id);
        //             if (type) {
        //                 member.type = type;
        //             }
        //         }
        //     }
        // }
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(async (params) => {
            this.mode = params.mode === 'true';
            this.uniqueId = params.uniqueId;
            if (this.mode) {
                await this.initializeForm(params.uniqueId);
            }
        });
    }

    async initializeForm(uniqueId: string) {
        try {
            this.form = await this.consentFormService.getCustomFormByUniqueId(uniqueId);
            if (this.form) {
                this.formTitle = this.form.title;
                this.formDescription = this.form.description;
                this.sections = JSON.parse(this.form.sections);

                for (const section of this.sections) {
                    section.expanded = false;
                    // section.title = section.title ? section.title.replace("'", "''") : '';
                    section.title = section.title ? section.title.replace(/'/g, "''") : '';
                    for (const member of section.members) {
                        // member.title = member.title ?  member.title.replace("'", "''") : '';
                        member.title = member.title ?  member.title.replace(/'/g, "''") : '';
                        const type = this.sectionTypes.find(t => t.id === member.type.id);
                        if (type) {
                            member.type = type;
                        }
                    }
                }
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να αρχικοποιήσουμε την δήλωση');
        } finally {
            this.isLoading = false;
        }
    }

    setSections() {
        const defaultSection = {
            id: this.sections.length + 1,
            label: 'Τίτλος',
            value: `Tίτλος τμήμα ${this.sections.length + 1}`,
            subLabel: 'Yπότιτλος',
            subLabelValue: '',
            direction: this.directionTypes[0],
            members: []
        };
        this.sections.push(defaultSection);
    }

    drop(event: CdkDragDrop<any[]>) {
        moveItemInArray(this.sections, event.previousIndex, event.currentIndex);
    }


    removeSection(id) {
        const index = this.sections.findIndex(s => s.id === id);
        if (index !== -1) {
            this.sections.splice(index, 1);
        }

        for (const section of this.sections) {
            if (section.id !== 1 && section.id > id) {
                section.id--;
            }
        }
    }

    addMember(id) {
        const section = this.sections.find(s => s.id === id);
        section.members.push({
            id: section.members.length + 1,
            type: this.sectionTypes[0],
            title: `Tίτλος τμήμα ${section.members.length + 1}`,
            value: null,
            options: [],
        });
    }

    removeMember(sectionId, memberId) {
        const section = this.sections.find(s => s.id === sectionId);
        const index = section.members.findIndex(m => m.id === memberId);

        if (index !== -1) {
            section.members.splice(index, 1);
        }

        for (const member of section.members) {
            if (member.id !== 1 && member.id > memberId) {
                member.id--;
            }
        }
    }


    addOption(sectionId: number, memberId) {
        const section = this.sections.find(s => s.id === sectionId);
        const member = section.members.find(m => m.id === memberId);

        const optionsDialog = this.dialog.open(AddOptionsDialogComponent, {
            width: '600px',
            height: '550px',
            data: {
                options: member.options
            }
        });

        optionsDialog.afterClosed().subscribe((result: any[]) => {
        });
    }

    isFormInValid() {
        if (!this.formDescription && !this.formDescription) {
            return true;
        } else {
            return false;
        }
    }

    async submitForm() {
        const model = {
            formTitle: this.formTitle,
            formDescription: this.formDescription,
            sections: JSON.stringify(this.sections)
        };

        try {
            localStorage.setItem('storedForm', JSON.stringify(model));
            await this.commonService.insertItem('forms/custom', model);
            this.location.back();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }
    async updateForm() {
        const model = {
            formId: this.form.id,
            formTitle: this.formTitle,
            formDescription: this.formDescription,
            sections: JSON.stringify(this.sections)
        };
        console.log(model.formId);
        try {
            // localStorage.setItem('storedForm', JSON.stringify(model));
            await this.commonService.updateItem('forms/custom', model);
            this.location.back();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε την φόρμα. Ελέγξτε για πιθανά (\'\') ');
        }
    }
}
